import { render, staticRenderFns } from "./AccountCreateSuccessForm.vue?vue&type=template&id=5525526c&scoped=true&"
import script from "./AccountCreateSuccessForm.vue?vue&type=script&lang=js&"
export * from "./AccountCreateSuccessForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5525526c",
  null
  
)

export default component.exports